import { render, staticRenderFns } from "./CommonProblems.vue?vue&type=template&id=676dd960&scoped=true&"
import script from "./CommonProblems.vue?vue&type=script&lang=js&"
export * from "./CommonProblems.vue?vue&type=script&lang=js&"
import style0 from "./CommonProblems.vue?vue&type=style&index=0&id=676dd960&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676dd960",
  null
  
)

export default component.exports